<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <!-- modal logout -->
  <div id="menu-logout" class="menu menu-box-modal bg-red-dark rounded-m" 
      data-menu-width="310">
    <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times-circle color-white shadow-xl rounded-circle"></i></h1>
    <h1 class="text-center mt-3 color-white font-700">Odhlásiť?</h1>
    <p class="boxed-text-l color-white opacity-70">
      Po odhlásení budú uložené dáta vymazané:<br>databáza, objednávky a podobne.<br>Naozaj sa chcete odhlásiť?
    </p>
    <div v-on:click="logout()" class="btn close-menu btn-m btn-center-m button-s shadow-l mb-4 rounded-s text-uppercase font-900 bg-white color-red-dark">odhlásiť</div>
  </div>
</template>

<script>
import auth from '@/lib/auth'

export default {
  name: 'LogoutModal',
  setup() {
  },
  methods: {
    logout: function () {
      auth.logout()
    }
  }
}
</script>
